import React from 'react';
import googleSheets from '../../images/integrations/Google-Sheets-Export.svg';

import IntegrationBot from '../../components/integrationn/index';

const GoogleSheetsExport = () => <IntegrationBot botLogo={googleSheets} botName={'Google Sheets (Export / Sync)'} />;

export default GoogleSheetsExport;
